var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFxCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.5 86.70000000000022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-1",
    opacity: 1,
    fillRule: "evenodd",
    d: "M77.73368530273456,78.37424850463867 C74.8023498535158,80.84911727905273 72.69999389648456,82.39999008178711 72.69999389648456,82.39999008178711 C72.69999389648456,82.39999008178711 60.50004272460956,86.69999313354492 54.30003051757831,86.69999313354492 C49.40000610351581,86.69999313354492 44.40000610351581,85.79999923706055 39.69999389648456,84.10000228881836 C28.800030517578307,80.19999313354492 20.199993896484557,72.29999923706055 15.199993896484557,61.899993896484375 C10.300030517578307,51.5 9.699993896484557,39.70000076293945 13.600018310547057,28.900001525878906 C17.500042724609557,18 25.400006103515807,9.399999618530273 35.80003051757831,4.399999618530273 C46.19999389648456,-0.5 58.00004272460956,-1.1000003814697266 68.8000305175783,2.799999237060547 C79.69999389648456,6.69999885559082 88.3000305175783,14.599998474121094 93.3000305175783,25 C98.19999389648456,35.39999771118164 98.8000305175783,47.19999694824219 94.9000061035158,58 C93.74357299804706,61.232025146484375 91.32108764648456,64.69265365600586 88.48502807617206,67.96213912963867 C90.7342346191408,64.81612777709961 92.5596740722658,61.33869171142578 93.9000061035158,57.600006103515625 C97.69999389648456,47 97.19999389648456,35.5 92.4000061035158,25.400001525878906 C87.5999572753908,15.200000762939453 79.0999572753908,7.5 68.4999816894533,3.700000762939453 C63.90000610351581,2.1000003814697266 58.99998168945331,1.2000007629394531 54.19999389648456,1.2000007629394531 C48.09995727539081,1.2000007629394531 41.99998168945331,2.6000003814697266 36.29996948242206,5.200000762939453 C26.099957275390807,10 18.400006103515807,18.5 14.599957275390807,29.099998474121094 C10.799969482422057,39.70000076293945 11.299969482422057,51.19999694824219 16.099957275390807,61.30000305175781 C20.900006103515807,71.49999618530273 29.400006103515807,79.19999313354492 39.99998168945331,82.99999618530273 C50.59995727539081,86.79999923706055 62.09995727539081,86.29999923706055 72.19999389648456,81.49999618530273 C74.13798217773456,80.58799362182617 75.9856994628908,79.54243087768555 77.73368530273456,78.37424850463867 C80.88651733398456,75.71242904663086 84.9982727050783,71.98173141479492 88.48502807617206,67.96213912963867 C85.56889038085956,72.04099655151367 81.94047241210956,75.56270980834961 77.73368530273456,78.37424850463867Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-2",
    opacity: 1,
    fillRule: "evenodd",
    d: "M44.70005493164081,70 C47.80003051757831,71.10000610351562 54.30003051757831,71.69999694824219 54.30003051757831,71.69999694824219 C54.30003051757831,71.69999694824219 62.40000610351581,70.80000305175781 66.3000305175783,69 C73.10001831054706,65.80000305175781 78.2000549316408,60.100006103515625 80.8000305175783,53 C86.10001831054706,38.400001525878906 78.4000061035158,22.200000762939453 63.80003051757831,16.900001525878906 C49.20005493164081,11.60000228881836 33.00004272460956,19.300003051757812 27.700054931640807,33.900001525878906 C25.100018310547057,41 25.500042724609557,48.69999694824219 28.700054931640807,55.5 C31.900006103515807,62.30000305175781 37.60001831054706,67.4000015258789 44.70005493164081,70 L31.400006103515807,54.19999694824219 C28.499981689453307,48.099998474121094 28.199993896484557,41.20000076293945 30.499981689453307,34.900001525878906 C35.19999389648456,21.799999237060547 49.69999389648456,15 62.79996948242206,19.700000762939453 C75.9000061035158,24.400001525878906 82.69999389648456,38.900001525878906 77.9999816894533,52 C75.69999389648456,58.400001525878906 71.0999572753908,63.400001525878906 64.9999816894533,66.30000305175781 C58.90000610351581,69.19999694824219 51.99998168945331,69.5 45.69999389648456,67.19999694824219 C39.29996948242206,64.9000015258789 34.29996948242206,60.30000305175781 31.400006103515807,54.19999694824219 L44.70005493164081,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-3",
    opacity: 1,
    fillRule: "evenodd",
    d: "M18.400006103515807,79.20000076293945 L18.799969482422057,79.60000991821289 L29.699993896484557,68.69999694824219 C33.29996948242206,72.20000076293945 37.49998168945331,74.89999771118164 42.29996948242206,76.60000991821289 C54.90000610351581,81.10000991821289 69.19999389648456,78.00000381469727 78.79996948242206,68.69999694824219 L89.69999389648456,79.70000076293945 C95.4000061035158,74.00000381469727 99.29996948242206,67.69999694824219 101.9000061035158,60.600006103515625 C108.4999816894533,42.19999694824219 103.79996948242206,21.400001525878906 90.0999572753908,7.600000381469727 L89.69999389648456,7.200000762939453 L78.79996948242206,18.099998474121094 C75.19999389648456,14.599998474121094 70.9999816894533,11.900001525878906 66.19999389648456,10.200000762939453 C53.59995727539081,5.700000762939453 39.29996948242206,8.80000114440918 29.699993896484557,18.099998474121094 L18.799969482422057,7.200000762939453 L18.400006103515807,7.600000381469727 C13.099957275390807,12.900001525878906 9.199993896484557,19.200000762939453 6.599957275390807,26.300003051757812 C-0.00001831054669310106,44.600006103515625 4.599957275390807,65.4000015258789 18.400006103515807,79.20000076293945 L7.600018310547057,26.599998474121094 C9.999981689453307,19.800003051757812 13.799969482422057,13.799999237060547 18.799969482422057,8.700000762939453 L29.600018310547057,19.599998474121094 L29.999981689453307,19.200000762939453 C39.29996948242206,9.900001525878906 53.40000610351581,6.700000762939453 65.79996948242206,11.200000762939453 C70.60001831054706,12.900001525878906 74.79996948242206,15.599998474121094 78.4000061035158,19.200000762939453 L78.79996948242206,19.599998474121094 L89.79996948242206,8.700000762939453 C102.9999816894533,22.200000762939453 107.4000061035158,42.400001525878906 100.9999816894533,60.19999694824219 C98.60001831054706,67 94.79996948242206,73.00000381469727 89.79996948242206,78.10000991821289 L78.9000061035158,67.19999694824219 L78.4999816894533,67.60000610351562 C69.19999389648456,76.89999771118164 55.10001831054706,80.10000991821289 42.69999389648456,75.60000991821289 C37.90000610351581,73.89999771118164 33.69999389648456,71.19999694824219 30.100018310547057,67.60000610351562 L29.699993896484557,67.19999694824219 L18.799969482422057,78.10000991821289 C5.600018310547057,64.60000610351562 1.199993896484557,44.400001525878906 7.600018310547057,26.599998474121094 L18.400006103515807,79.20000076293945Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-4",
    opacity: 1,
    fillRule: "evenodd",
    d: "M28.800000000000182,80.8 C11.800000000000182,69.2 4.800000000000182,47.49999999999999 11.800000000000182,28.199999999999996 C16.700000000000188,14.499999999999998 28.10000000000018,4 42.10000000000018,0 L43.500000000000185,4.800000000000001 C31.000000000000185,8.3 21.000000000000185,17.7 16.600000000000193,29.900000000000002 C10.40000000000019,47.099999999999994 16.600000000000193,66.4 31.800000000000196,76.69999999999999 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-5",
    opacity: 1,
    fillRule: "evenodd",
    d: "M99.29999999999998,46.09999999999998 L94.29999999999998,45.79999999999998 C94.6,40.999999999999986 93.99999999999999,36.199999999999974 92.6,31.599999999999966 C91.2,26.99999999999996 89,22.69999999999996 86,18.89999999999996 L90,15.799999999999955 C93.3,20.09999999999996 95.8,24.89999999999996 97.39999999999999,30.099999999999966 C98.99999999999999,35.299999999999976 99.6,40.699999999999974 99.29999999999998,46.09999999999998Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-6",
    opacity: 1,
    fillRule: "evenodd",
    d: "M69.89999999999982,85.79999999999995 L68.19999999999982,81.09999999999995 C73.59999999999982,79.09999999999995 78.59999999999982,75.89999999999995 82.69999999999982,71.79999999999995 C86.79999999999981,67.69999999999996 89.99999999999982,62.69999999999996 91.99999999999982,57.299999999999955 L96.69999999999982,58.99999999999996 C94.39999999999982,65.09999999999995 90.79999999999981,70.79999999999995 86.19999999999982,75.39999999999995 C81.59999999999982,79.89999999999995 75.99999999999982,83.59999999999995 69.89999999999982,85.79999999999995Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-empty-circle-7",
    opacity: 1,
    fillRule: "evenodd",
    d: "M78.50000000000018,11.500000000000046 C78.20000000000019,11.200000000000045 77.80000000000018,11.000000000000046 77.50000000000018,10.800000000000047 C75.50000000000018,9.400000000000048 73.50000000000018,8.200000000000045 71.30000000000018,7.2000000000000455 L73.40000000000018,2.7000000000000455 C75.80000000000018,3.800000000000045 78.20000000000019,5.2000000000000455 80.40000000000018,6.800000000000043 C80.80000000000018,7.100000000000044 81.20000000000019,7.400000000000045 81.50000000000018,7.600000000000044 "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-8",
    opacity: 1,
    x: 53.69999999999982,
    y: 7.2000000000000455,
    width: 1,
    height: 3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-9",
    opacity: 1,
    x: 22.600000000000364,
    y: 25.600000000000023,
    width: 3,
    height: 1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-10",
    opacity: 1,
    x: 19.199999999999818,
    y: 34,
    width: 3,
    height: 1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-11",
    opacity: 1,
    x: 18,
    y: 42.89999999999998,
    width: 3,
    height: 1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-12",
    opacity: 1,
    x: 20.199999999999818,
    y: 50.89999999999998,
    width: 1,
    height: 3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-13",
    opacity: 1,
    x: 23.600000000000364,
    y: 59.299999999999955,
    width: 1,
    height: 3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-14",
    opacity: 1,
    x: 53.69999999999982,
    y: 76.70000000000005,
    width: 1,
    height: 3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-15",
    opacity: 1,
    x: 82.80000000000018,
    y: 60.299999999999955,
    width: 3,
    height: 1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-16",
    opacity: 1,
    x: 86.30000000000018,
    y: 51.89999999999998,
    width: 3,
    height: 1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-17",
    opacity: 1,
    x: 87.5,
    y: 42.89999999999998,
    width: 3,
    height: 1,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-18",
    opacity: 1,
    x: 87.30000000000018,
    y: 32.89999999999998,
    width: 1,
    height: 3,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-19",
    opacity: 1,
    x: 83.80000000000018,
    y: 24.600000000000023,
    width: 1,
    height: 3,
    rx: 0,
    ry: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-1",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-2",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-3",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-4",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-5",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-6",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-empty-circle-7",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-8",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-9",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-10",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-11",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-12",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-13",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-14",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-15",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-16",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-17",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-18",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-19",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxCircle1);
export default __webpack_public_path__ + "static/media/fx-circle-1.b11764286e32406b0cb4081510e4827f.svg";
export { ForwardRef as ReactComponent };